import { graphql } from '@/utils/graphql';

export const matchdayHeaderTweetFragment = graphql(`
  fragment matchdayHeaderTweetFields on matchdays {
    name
    start_datetime
    country {
      emoji
    }
    season {
      name
      competition {
        name
        parent {
          name
        }
      }
    }
  }
`);
